const namedEntities = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  '#39': "'",
  nbsp: ' ',
  '#x2F': '/',
  '#X2F': '/',
  '#47': '/',
};

const decodeEntity = entity => {
  if (!entity) return entity;

  if (namedEntities[entity]) {
    return namedEntities[entity];
  }

  if (entity[0] === '#') {
    const isHex = entity[1]?.toLowerCase() === 'x';
    const rawValue = isHex ? entity.slice(2) : entity.slice(1);
    const codePoint = parseInt(rawValue, isHex ? 16 : 10);

    if (!Number.isNaN(codePoint)) {
      try {
        return String.fromCodePoint(codePoint);
      } catch (e) {
        return `&${entity};`;
      }
    }
  }

  return `&${entity};`;
};

export const decodeHtmlEntities = value => {
  if (typeof value !== 'string' || !value.includes('&')) {
    return value;
  }

  if (typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  return value.replace(/&([^;]+);/g, (_, entity) => decodeEntity(entity));
};
